import { externalIntegrationsRepositorySingleton } from '@warehouse/object-browser/infra';
import { QuickbaseTabService } from './quickbase-tab.service';
import { TabType } from '../quickbase-types';
import { appendEmbedParams, IframeEmbedParams } from '../quickbase-host-bridge/iframe-url-state';

export interface QuickbaseTabConfig {
	appID: string;
	tableID: string;
	fieldID: string;
	pageID: string;
	formID: string;
	queryParams?: string;
	auth0: {
		domain: string;
		clientId: string;
	};
	serviceURL: string;
}

export class QuickbaseTabServiceImpl implements QuickbaseTabService {
	constructor(private readonly tabType: TabType) {}

	private getConfiguration(): QuickbaseTabConfig {
		const integration = externalIntegrationsRepositorySingleton.get().getExternalTab(this.tabType);

		if (!integration) {
			throw new Error(`${integration} integration not found`);
		}

		const { params, serviceURL } = integration;

		return {
			serviceURL,
			appID: params.appID,
			tableID: params.tableID,
			fieldID: params.fieldID,
			pageID: params.pageID,
			formID: params.formID,
			queryParams: params.queryParams,
			auth0: {
				domain: params.auth0Domain,
				clientId: params.auth0ClientId,
			},
		};
	}

	buildEmbedUrl(titleUuid: string, embedParams?: IframeEmbedParams): string {
		const config = this.getConfiguration();
		if (config.queryParams?.includes('a=dbpage')) {
			return appendEmbedParams(
				`${config.serviceURL}db/${config.appID}?${config.queryParams}&pageID=${config.pageID}&key=${titleUuid}`,
				embedParams ?? {},
			);
		}
		const queryParams = config.queryParams ? `&${config.queryParams}` : '';
		return appendEmbedParams(
			`${config.serviceURL}nav/app/${config.appID}/table/${config.tableID}/action/dr?${config.fieldID}=${titleUuid}&page=${config.pageID}&dfid=${config.formID}${queryParams}`,
			embedParams ?? {},
		);
	}

	validateConfiguration(): boolean {
		try {
			/**
			 * If the configuration is not present getConfiguration throws
			 */
			this.getConfiguration();

			return true;
		} catch {
			return false;
		}
	}
}
